import React from 'react';
import CompanyName from './CompanyName';
import WelcomeImage from '../Images/BagdadChase.jpg';
import ComingSoon from './ComingSoon';
import { Button, ThemeProvider, createTheme } from '@mui/material';
import { SendHorizontal } from 'lucide-react';

const theme = createTheme({
    palette: {
        primary: {
            main: "#99aab5", // custom primary color
        },
        secondary: {
            main: "#DB504A", // custom secondary color
        },
    },
});

const Hero = () => {
    return (
        <div className="relative w-full h-screen">
            {/* Background Image */}
            <img
                src={WelcomeImage}
                alt="Welcome"
                className="absolute top-0 left-0 w-full h-full object-cover z-0"
            />

            {/* Overlay Content */}
            <div className="absolute top-0 left-0 w-full h-full flex flex-col justify-center items-center text-white z-10 bg-[#06070E] bg-opacity-50">
                <div className="text-3xl text-center pb-5">Welcome to</div>
                <div className="text-6xl font-bold pb-10 text-center uppercase text-[#DAA520]" style={{ textShadow: '4px 4px 8px rgba(0, 0, 0, 0.8)' }}>
                    <div>The</div>
                    <div>Bagdad Chase</div>
                    <div>Mining Company</div>
                </div>

                <div className="my-10 w-1/3">
                    <ThemeProvider theme={theme}>
                        <Button
                            fullWidth
                            variant="contained"
                            id="btnSubmit"
                            color="secondary"
                            size="large"
                            title="Contact The Bagdad Chase Mining Company"
                        >
                            <SendHorizontal />&nbsp;&nbsp;<b>Contact</b>
                        </Button>
                    </ThemeProvider>
                </div>
            </div>
        </div>
    );
};

export default Hero;
